import Stack from '@mui/material/Stack';
import { Trans } from 'react-i18next';

export function RepresentativeTerms() {
  return (
    <Stack gap="10px">
      <Trans i18nKey="loanFormPage.agreements.form.fields.representative.content" />
    </Stack>
  );
}
